import api from './api';
import { Category } from '../types/types';

export const categoryService = {
    // Get all categories
    getAllCategories: async (): Promise<Category[]> => {
        const response = await api.get<Category[]>('/categories');
        return response.data;
    },

    // Get category by ID
    getCategoryById: async (id: number): Promise<Category> => {
        const response = await api.get<Category>(`/categories/${id}`);
        return response.data;
    },

    // Create new category
    createCategory: async (category: Partial<Category>): Promise<Category> => {
        // Map frontend property names to backend (PascalCase)
        const payload = {
            Name: category.name,
            Description: category.description || ''
        };
        const response = await api.post<Category>('/categories', payload);
        return response.data;
    },

    // Update category
    updateCategory: async (id: number, category: Partial<Category>): Promise<void> => {
        // Map frontend property names to backend (PascalCase)
        const payload = {
            Id: id,
            Name: category.name,
            Description: category.description || ''
        };
        await api.put(`/categories/${id}`, payload);
    },

    // Delete category
    deleteCategory: async (id: number): Promise<void> => {
        await api.delete(`/categories/${id}`);
    },
};
